import PropTypes from 'prop-types'
import { get, head, isEmpty } from 'lodash'
import styled from 'styled-components'

import { Typography, Box, Divider } from '@material-ui/core'
import { TextStyles } from 'utils/text'

import {
  findFixedProduct,
  findTVPermanents,
  getFeesPendingFromPermanent,
} from 'services/subscriptions'

import { PermanencyTab } from './PermanencyTab'
import { PendingAndTotalFee } from './PendingAndTotalFee'

export const PermanencyAgileTv = styled(({ className, subscription }) => {
  const product = findFixedProduct(subscription)
  const permanent = head(findTVPermanents(subscription))

  return product ? (
    <div className={className}>
      <Typography
        {...TextStyles.subtitle1Secondary({
          className: 'txt-none p-b-12',
        })}>
        Agile TV
      </Typography>
      <div className="flex">
        {!isEmpty(permanent) && (
          <>
            <PermanencyTab validFor={permanent.validFor} totalMonths={permanent.length} />

            <Box mt="8px">
              <Divider orientation="vertical" />
            </Box>

            <PendingAndTotalFee
              className="p-l-24"
              title="Penalización"
              pendingFee={getFeesPendingFromPermanent(permanent)}
              totalFee={get(permanent, 'fees.penalty', 0)}
            />
          </>
        )}
        <Box mt="8px">
          <Divider orientation="vertical" />
        </Box>
      </div>
    </div>
  ) : null
})`
  .txt-none {
    text-transform: none;
  }
`

PermanencyAgileTv.propTypes = {
  className: PropTypes.string,
}
